import * as React from 'react';
import * as _ from 'lodash/fp';
import styled from 'styled-components';

import { getColor, type Theme } from '@process-advisor/process-miner/shared/theme';

type StyleProps = {
    width?: string,
    borderBottom?: boolean,
    borderTop?: boolean,
    borderLeft?: boolean,
    borderRight?: boolean,
    marginLeft?: boolean,
    direction?: string
}

const getBorder = _.curry((
    propName: string,
    props: StyleProps & { theme: Theme }
) => props[propName]
    ? `1px solid ${getColor('borderColor')(props)}`
    : 'none');

const Wrapper = styled.div<StyleProps>`
    display: flex;
    justify-content: left;
    align-items: flex-start;
    flex-direction: column;
    width: ${({ width }) => width || '100%'};
    border-left: ${getBorder('borderLeft')};
    border-bottom: ${getBorder('borderBottom')};
    border-top: ${getBorder('borderTop')};
    border-right: ${getBorder('borderRight')};
    padding-left: 5px;
    position: relative;
    margin-left: ${getBorder('marginLeft')};
`;

type Props = StyleProps;

export const SingleBlock: React.FC<Props> = ({
    children,
    ...props
}) => (
    <Wrapper {...props}>
        {children}
    </Wrapper>
);
